export default __webpack_public_path__ + "static/media/Snd_TryC.3b0819cb.mp3";